export default __webpack_public_path__ + "static/media/logoUtama.22542549.svg";